"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var EmailValidator = _interopRequireWildcard(require("email-validator"));
var _OverviewContactInfo = _interopRequireDefault(require("../OverviewContactInfo"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var MailIcon = function MailIcon(props) {
  return /*#__PURE__*/_react.default.createElement("svg", props, /*#__PURE__*/_react.default.createElement("path", {
    d: "M6.413 7.003 12 12.592l5.587-5.59H6.413zM19 8.418l-6.293 6.295a1 1 0 0 1-1.414 0L5 8.418v8.59h14v-8.59zM3 7.003a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v10.005a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V7.002z"
  }));
};
MailIcon.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
var emailValidator = function emailValidator(value) {
  var isValid = true;
  if (value === null || value === '') {
    isValid = true;
  } else {
    isValid = EmailValidator.validate(value);
  }
  return {
    isValid: isValid,
    errorMessage: 'Invalid email address'
  };
};
var OverviewContactEmail = function OverviewContactEmail(_ref) {
  var asset = _ref.asset,
    canEdit = _ref.canEdit,
    updateContactInfo = _ref.updateContactInfo;
  var renderIcon = function renderIcon() {
    return /*#__PURE__*/_react.default.createElement(MailIcon, null);
  };
  var renderField = function renderField() {
    return /*#__PURE__*/_react.default.createElement("a", {
      href: "mailto:".concat(asset.contactEmail),
      "aria-label": "Send contact information email"
    }, asset.contactEmail);
  };
  return /*#__PURE__*/_react.default.createElement(_OverviewContactInfo.default, {
    asset: asset,
    canEdit: canEdit,
    updateContactInfo: updateContactInfo,
    valueValidator: emailValidator,
    renderIcon: renderIcon,
    renderField: renderField,
    actionMethod: "updateContactEmail",
    placeholder: "Add email",
    fieldLabel: "Contact email"
  });
};
var _default = exports.default = OverviewContactEmail;
//# sourceMappingURL=OverviewContactEmail.js.map